<template>
    <section class="incidents">
      <h2 class="section-title">
        Besondere Vorkommnise
        <span class="material-icons">
          announcement
        </span>
      </h2>
      <div v-if="flightLog.incidentLogs.length">
        <div v-for="incidentLog in flightLog.incidentLogs" :key="incidentLog.id" >
          <div class="log">
                <span class="incident-creator">
                    [{{incidentLog.user.firstName}} {{incidentLog.user.lastName}}: {{incidentLog.incidentTime.substring(11,16)}}]
                </span>
                <span class="text">
                  {{incidentLog.incident}}
                </span>    
          </div>
          
        </div>
      </div>
      <div v-else>
        Heute gab es noch keine besonderen Vorkommnisse!
      </div>
 
  </section>

</template>

<script>

export default {
    name:'IncidentPanel',
    props: ['flightLog'],

}
</script>

<style scoped>
 .incidents {
   background:#fff;
   margin:0;
 }

 .section-title {
   display:inline-block;
   margin: 20px 0;
 }

 .material-icons {
  /* display:inline-block; */
  color: green;
  padding: 0px 1px;
  font-size: 24px;
  /* border-right: 1px solid darkgray; */
  line-height: 30px;
}


.log {
  border: 2px solid green;
  margin: 8px 8px;
  border-radius: 15px;
  text-align: left;
  font-size: 16px;
  background-color: #f5f5f5;
  padding: 10px;
}

.text { 
    margin: 2px 0;
}

.incident-creator {
  font-style: italic;
}

</style>